module.exports = __webpack_public_path__ + "static/media/other.e4dee48c.svg";